import AboutNavigationDesktop from './Desktop/AboutNavigationDesktop';
import AboutNavigationMobile from './Mobile/AboutNavigationMobile';

import styles from './AboutNavigation.module.scss';

const AboutNavigation = ({sections}) => {

    function handleTabClick(tab){
        sections[tab].current.scrollIntoView({behavior: "smooth"})
        history.pushState({},sections[tab].current.id, `#${sections[tab].current.id}`);
    }

    return ( 
        <div className={`${styles.aboutNavigation}`}>
            <span className={styles.aboutNavigation__desktop}>
                <AboutNavigationDesktop onClick={(tab)=>handleTabClick(tab)} />
            </span>

            <span className={styles.aboutNavigation__mobile}>
                <AboutNavigationMobile onClick={(tab)=>handleTabClick(tab)} />
            </span>
        </div>
     );
}
 
export default AboutNavigation;